import { render } from "./offeringForm.vue?vue&type=template&id=aa713510"
import script from "./offeringForm.vue?vue&type=script&lang=js"
export * from "./offeringForm.vue?vue&type=script&lang=js"

import "./offeringForm.vue?vue&type=style&index=0&id=aa713510&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__